import axios from "axios";
import {
  containsPaidAdminOrder,
  promptForPaidOrderDeletion,
} from "../../components/admin/adminOrderDeleteConfirmation";

export default function useAdminOrderActions({
  apiBaseUrl,
  closeDriverSchedule,
  fetchOrders,
  getErrorMessage,
  handleEditOrder,
  orders,
  openDuplicateOrderForm,
  refreshStats,
  setActiveTab,
  setLoading,
}) {
  const refreshOrdersAndStats = () => {
    fetchOrders();
    refreshStats?.();
  };

  const handleOpenRecentOrder = async (orderId) => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${apiBaseUrl}/orders/${orderId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      handleEditOrder(res.data);
      setActiveTab("orders");
    } catch (err) {
      console.error("获取订单详情失败:", err);
    }
  };

  const handleViewDriverScheduleOrder = (order) => {
    closeDriverSchedule();
    const foundOrder = orders.find((item) => item.id === order.id);
    if (!foundOrder) {
      alert("订单数据未加载，请先刷新订单列表");
      return;
    }

    handleEditOrder(foundOrder);
  };

  const handleUnlockOrder = async (orderId) => {
    setLoading(true);
    try {
      await axios.post(`${apiBaseUrl}/admin/orders/${orderId}/unlock`);
      alert("订单修改权限已开放！");
      refreshOrdersAndStats();
    } catch (error) {
      alert("操作失败");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteOrder = async (orderId) => {
    const order = orders.find((item) => item.id === orderId);
    let confirmationText = null;
    if (containsPaidAdminOrder(order ? [order] : [])) {
      confirmationText = promptForPaidOrderDeletion();
      if (!confirmationText) return;
    } else if (!window.confirm("确定要删除此订单吗？此操作不可撤销。")) {
      return;
    }

    setLoading(true);
    try {
      await axios.delete(`${apiBaseUrl}/admin/orders/${orderId}/permanent`, {
        data: { confirmation_text: confirmationText },
      });
      alert("订单删除成功！");
      refreshOrdersAndStats();
    } catch (error) {
      alert(getErrorMessage(error, "删除订单失败"));
    } finally {
      setLoading(false);
    }
  };

  const handleRestoreOrder = async (orderId) => {
    const confirmText = window.prompt("请输入「恢复」确认恢复此订单：");
    if (confirmText !== "恢复") {
      if (confirmText !== null) {
        alert("输入不正确，请输入「恢复」");
      }
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${apiBaseUrl}/admin/orders/${orderId}/restore`);
      alert("订单已恢复！");
      refreshOrdersAndStats();
    } catch (error) {
      alert(getErrorMessage(error, "恢复订单失败"));
    } finally {
      setLoading(false);
    }
  };

  const handleDuplicateOrder = (order) => {
    if (!window.confirm("复制只会带入上下车地址、姓名和电话。请完整填写日期、时间、车型、价格等信息并提交后，系统才会创建全新订单。")) return;
    openDuplicateOrderForm(order);
  };

  return {
    handleDeleteOrder,
    handleDuplicateOrder,
    handleOpenRecentOrder,
    handleRestoreOrder,
    handleUnlockOrder,
    handleViewDriverScheduleOrder,
  };
}
